import React from "react";

import Flexbox from "core/Flexbox";
import Link from "core/Link";

import { useReleases } from "./hooks/useReleases";

import {
    ReleasesDropdownError,
    ReleasesDropdownErrorContainer
} from "./styles";

import { tooManyReleasesErrorMsg } from "../../PhotoUpload/Edit/constants";

const ReleasesUploadError = () => {
    const { releaseUploadErrorMessage } = useReleases();

    const showRequirementsLink =
        releaseUploadErrorMessage !== tooManyReleasesErrorMsg;

    return releaseUploadErrorMessage ? (
        <ReleasesDropdownErrorContainer>
            <Flexbox
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
            >
                <ReleasesDropdownError>
                    {releaseUploadErrorMessage}
                </ReleasesDropdownError>

                {showRequirementsLink && (
                    <Link href="#" disableVisitedStyle>
                        Requirements
                    </Link>
                )}
            </Flexbox>
        </ReleasesDropdownErrorContainer>
    ) : null;
};

export default ReleasesUploadError;
